import React from "react";
import { useGLTF } from "@react-three/drei";

export function RoomDecorado(props) {
    const { nodes, materials } = useGLTF(
        "/ModeladoFinalDecoracionPlantas_SinTV.glb"
    );
    return (
        <group {...props} dispose={null}>
            <mesh
                geometry={nodes.Television.geometry}
                material={materials.CheckerPlants}
                // material={new MeshStandardMaterial({map: materials.CheckerPlants.map })}
            />
        </group>
    );
}

useGLTF.preload("/ModeladoFinalDecoracionPlantas_SinTV.glb");

